import {
  ENDPOINT_MARKETING_BASE_PATH,
  X_API_KEY,

  ENDPOINT_MARKETING_GET_POTENTIAL_AUDIENCE,
  ENDPOINT_MARKETING_GET_USERS_LIST_MANUAL,
  ENDPOINT_MARKETING_GET_AUDIENCE_USERS,
  ENDPOINT_MARKETING_GET_OPERATIONS,
  ENDPOINT_MARKETING_GET_USERS_LIST,
  ENDPOINT_MARKETING_GET_AUDIENCE,
  ENDPOINT_MARKETING_APP_PAGES,

  ENDPOINT_MARKETING_SET_AUDIENCE,
  ENDPOINT_MARKETING_SET_OPERATION,
  
  ENDPOINT_MARKETING_UPDATE_OPERATION,
  ENDPOINT_MARKETING_UPDATE_AUDIENCE,
  
  ENDPOINT_MARKETING_DELETE_OPERATION,
  ENDPOINT_MARKETING_DELETE_AUDIENCE,
  ENDPOINT_MARKETING_APP_COUPONS,
  ENDPOINT_MARKETING_APP_ACTIVITIES,
  ENDPOINT_MARKETING_APP_CAMPAIGNS,
} from "./Globals";



/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// impostare un audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiSetAudience = async (
   publicCode,
   body
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_SET_AUDIENCE}?public_code=${publicCode}`, {
      method: "POST",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// impostare un audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// recuperare audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiGetAudience = async (
   publicCode,
   audienceId,
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_GET_AUDIENCE}?public_code=${publicCode}&id=${audienceId}`, {
      method: "GET",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};
 
const apiGetAllAudiences = async (
   publicCode,
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_GET_AUDIENCE}?public_code=${publicCode}`, {
      method: "GET",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
    });
    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// recuperare audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// cancellare audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiDeleteAudience = async (
   publicCode,
   body, //array di id audiences
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_DELETE_AUDIENCE}?public_code=${publicCode}`, {
      method: "DELETE",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
       },
      body:JSON.stringify(body)
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// cancellare audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// modificare audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiEditAudience = async (
  publicCode,
  audienceId,
  body,
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_UPDATE_AUDIENCE}?public_code=${publicCode}&id=${audienceId}`, {
      method: "PATCH",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
       },
      body:JSON.stringify(body)
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// modificare audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// calcola potential audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiGetPotentialAudience = async (
  publicCode,
  body
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_GET_POTENTIAL_AUDIENCE}?public_code=${publicCode}&include_users=false&page=1`, {
      method: "POST",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
      body:JSON.stringify(body)
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// calcola potential audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// ottieni utenti dell'audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiGetUsersByAudienceId = async (
  publicCode,
  audienceId,
  page,
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_GET_AUDIENCE_USERS}?public_code=${publicCode}&include_users=true&page=${page}&id=${audienceId}`, {
      method: "GET",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};
 
const apiGetAllUsers = async (
  publicCode,
  page,
  searchString,
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_GET_AUDIENCE_USERS}?public_code=${publicCode}&include_users=true&page=${page}&id=&search=${searchString}`, {
      method: "GET",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {
    alert(_)
  }

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// ottieni utenti dell'audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// anagrafica utenti di quell'audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiGetUsersList = async (
  body,
  searchString
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_GET_USERS_LIST}?search=${searchString}`, {
      method: "POST",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
      body:JSON.stringify(body)
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// anagrafica utenti di quell'audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// anagrafica utenti aggiunti forzatamanete in un audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiGetUsersListManual = async (
  body,
  searchString
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_GET_USERS_LIST_MANUAL}?search=${searchString}`, {
      method: "POST",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
      body:JSON.stringify(body)
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// anagrafica utenti aggiunti forzatamanete in un audience ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 

///////////////////////////////////////////////////////////////////////////////////////////
          //////////////////// API DELLE OPERAZIONI ///////////////
///////////////////////////////////////////////////////////////////////////////////////////

const apiSetOperation = async (
  body
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_SET_OPERATION}`, {
      method: "POST",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
      body:JSON.stringify(body)
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

const apiUpdateOperation = async (
  body
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_UPDATE_OPERATION}`, {
      method: "PATCH",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
      body:JSON.stringify(body)
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

const apiGetOperations = async (
  publicCode
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_GET_OPERATIONS}?public_code=${publicCode}`, {
      method: "GET",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};
const apiGetOperation = async (
  publicCode,
  id
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_GET_OPERATIONS}?public_code=${publicCode}&id=${id}`, {
      method: "GET",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

const apiDeleteOperation = async (
  publicCode,
  operationId
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_DELETE_OPERATION}?public_code=${publicCode}&id=${operationId}`, {
      method: "DELETE",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
      },
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
          //////////////////// API DELLE OPERAZIONI /////////////// 
/////////////////////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// ottieni le pagine app ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiGetAllAppPages = async (
  appToken,
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_APP_PAGES}?token_key=${appToken}`, {
      method: "GET",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
       },
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// ottieni le pagine app ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// ottieni i coupons delle app ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiGetAllAppCoupons = async (
  appToken,
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_APP_COUPONS}?token_key=${appToken}`, {
      method: "GET",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
       },
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// ottieni i coupons delle app ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// ottieni le attività delle app ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiGetAllAppActivities = async (
  appToken,
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_APP_ACTIVITIES}?token_key=${appToken}`, {
      method: "GET",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
       },
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// ottieni le attività delle app ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// ottieni le campagne delle app ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 
const apiGetAllAppCampaigns = async (
  appToken,
) => {
  try {
    const response = await fetch(`${ENDPOINT_MARKETING_BASE_PATH}/${ENDPOINT_MARKETING_APP_CAMPAIGNS}?token_key=${appToken}`, {
      method: "GET",
      headers: {
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json",
       },
    });

    if (response) {
      const json = await response.json();
      return json.message ? { message: json.message } : json;
    }
  } catch (_) {}

  return null;
};

/////////////////////////////////////////////////////////////////////////////////////////// 
         //////////////////// ottieni le campagne delle app ///////////////
/////////////////////////////////////////////////////////////////////////////////////////// 
 


export {
  apiGetUsersByAudienceId,
  apiGetPotentialAudience,
  apiGetUsersListManual,
  apiGetAllAudiences,
  apiDeleteAudience,
  apiEditAudience,
  apiGetUsersList,
  apiGetAudience,
  apiSetAudience,

  apiUpdateOperation,
  apiDeleteOperation,
  apiGetOperations,
  apiGetOperation,
  apiSetOperation,
  
  apiGetAllAppActivities,
  apiGetAllAppCampaigns,
  apiGetAllAppCoupons,
  apiGetAllAppPages,
}